module.exports = __webpack_public_path__ + "static/media/TRAVERSE GUIDE MOULDING - ROUND ( 466 - 00256 ) FOR SDS 900 - 1200 MACHINES..a178f3f2.jpg";